import { MdArrowForwardIos } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { formatDateToTimeStr } from '../utils';
import ReactLoading from 'react-loading';
import { useNotifications } from '../Hooks/useNotifications';

export const NotificationCard = () => {
  // const [hover, setHover] = useState(false);
  const navigate = useNavigate();

  const {
    isSubmiting,
    isLoading,
    handleClearNotification,
    goToNotification,
    newNotifications,
  } = useNotifications();

  // const NotificationData = [
  //   {
  //     id: 1,
  //     tracker: 'B',
  //     title: 'Bidding Offer',
  //     body: 'You have a buy FX request offer therefore you are ....',
  //     time: '2 min ago',
  //   },
  //   {
  //     id: 2,
  //     tracker: 'B',
  //     title: 'Sell Offer',
  //     body: 'You have a buy FX request offer therefore you are ....',
  //     time: '2 min ago',
  //   },
  // ];

  // const handlenavigate = () => {
  //   navigate('/notifications');
  // };

  return (
    <div className='flex flex-col gap-4 max-w-sm bg-p-wh drop-shadow-md py-6'>
      <h1 className='font-semibold ps-6'>Notifications</h1>
      <div className='w-full grid grid-rows-2'>
        {isLoading ? (
          <div className='w-full flex flex-row gap-4 items-center border-t-hf px-6 py-2 text-p-wh hover:bg-f-bk hover:text-t-bk'>
            <ReactLoading type='cylon' color='#5AC8FA' height={44} width={44} />
          </div>
        ) : newNotifications.length === 0 ? (
          <div className='w-full px-6 py-2 text-p-bk font-medium'>
            No new notification!
          </div>
        ) : (
          newNotifications?.slice(0, 3).map((notification) => {
            return (
              <div
                className={`flex flex-row gap-4 items-center border-t-hf px-6 py-2 hover:bg-f-bk hover:text-t-bk`}
                onClick={() => goToNotification(notification.id)}
                key={notification.id}
              >
                <div className='flex flex-row gap-4 items-start'>
                  <div className='w-fit h-fit px-4 py-2 bg-p-wh drop-shadow text-s-bk rounded-full flex justify-center items-center'>
                    {notification.title?.split(' ')[0][0]}
                  </div>
                  <div className='w-full flex flex-col gap-2 rounded-lg'>
                    <h2 className=' text-p-bk'>{notification.title}</h2>

                    <div className='text-xs flex flex-col gap-1 text-s-bk'>
                      <p>{notification?.message}</p>
                      <small>
                        {formatDateToTimeStr(notification.created_at)}
                      </small>
                    </div>
                  </div>
                </div>

                <div className='px-2 py-2 rounded-md '>
                  <MdArrowForwardIos />
                </div>
              </div>
            );
          })
        )}
      </div>
      <div className='border-hf mx-6 h-[56px] overflow-hidden rounded-lg flex flex-row items-center justify-between'>
        <button
          className='flex flex-row gap-2 items-center hover:bg-b-mc p-4 hover:text-p-wh disabled:bg-t-wh disabled:text-s-bk disabled:hover:text-s-bk '
          disabled={!newNotifications.length}
          onClick={handleClearNotification}
        >
          <span className='font-medium'>
            {!isSubmiting ? (
              'Clear All'
            ) : (
              <ReactLoading
                type='cylon'
                color='#5AC8FA'
                height={44}
                width={44}
              />
            )}
          </span>
        </button>
        <button
          className='flex flex-row gap-2 items-center hover:bg-b-mc p-4 [&>*]:hover:text-p-wh'
          onClick={() => navigate('/notifications')}
        >
          <span className='text-b-mc text-base'>SeeAll</span>
          <div className='bg-f-bk px-2 py-2 rounded-md text-b-mc'>
            <MdArrowForwardIos className='h-full w-full' />
          </div>
        </button>
      </div>
    </div>
  );
};
